<template>
  <v-app>
    <v-app-bar app color="white" elevation="1">
      <v-toolbar-title class="red--text">offer先生</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        v-for="item in menuItems"
        :key="item"
        class="text-capitalize"
        >{{ item }}</v-btn
      >
      <v-btn color="error" class="ml-2">我要发布</v-btn>
      <v-btn outlined color="error" class="ml-2">企业入口</v-btn>
    </v-app-bar>

    <v-main class="red lighten-1">
      <v-container fluid class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" md="6" class="pa-10">
            <h1 class="display-2 font-weight-bold white--text mb-6">
              看招聘信息<br />就上offer先生!
            </h1>
            <v-btn color="white" class="red--text text-capitalize"
              >热门岗位</v-btn
            >
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="pa-10 d-flex justify-space-around align-center"
          >
            <div>
              <div class="text-h4 white--text">最近 24h 更新</div>
              <div class="text-h2 white--text font-weight-bold">61</div>
            </div>
            <div>
              <div class="text-h4 white--text">累计更新</div>
              <div class="text-h2 white--text font-weight-bold">25697</div>
            </div>
            <div>
              <div class="text-h4 white--text">今日截止</div>
              <div class="text-h2 white--text font-weight-bold">2</div>
            </div>
            <v-card
              width="150"
              height="150"
              class="d-flex justify-center align-center"
            >
              <v-img
                src="/placeholder.svg"
                alt="QR Code"
                width="120"
                height="120"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>

        <v-sheet color="white" class="pa-6">
          <v-slide-group show-arrows>
            <v-slide-item v-for="n in 10" :key="n" class="mr-4">
              <v-avatar size="64" color="grey lighten-2">
                <v-img src="/placeholder.svg"></v-img>
              </v-avatar>
            </v-slide-item>
          </v-slide-group>

          <v-text-field
            solo
            placeholder="搜索职位、公司、42760家企业职位已更新"
            append-icon="mdi-magnify"
            class="mt-6"
          ></v-text-field>

          <v-tabs>
            <v-tab>24h更新 (25683)</v-tab>
            <v-tab>校招合集</v-tab>
            <v-tab>即将截止</v-tab>
            <v-tab>我的收藏</v-tab>
          </v-tabs>

          <v-row class="mt-4">
            <v-col cols="12" md="2">
              <h3 class="subtitle-1">行业:</h3>
              <v-chip-group column>
                <v-chip small>不限</v-chip>
                <v-chip small>金融业</v-chip>
                <v-chip small>IT互联网/游戏</v-chip>
                <v-chip small>房地产/建筑业</v-chip>
              </v-chip-group>
            </v-col>
            <v-col cols="12" md="10">
              <h3 class="subtitle-1">城市:</h3>
              <v-chip-group>
                <v-chip small>全国</v-chip>
                <v-chip small>国外</v-chip>
                <v-chip small>北京</v-chip>
                <v-chip small>上海</v-chip>
                <v-chip small>广州</v-chip>
                <v-chip small>深圳</v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="2">
              <h3 class="subtitle-1">职位:</h3>
              <v-chip-group column>
                <v-chip small>不限</v-chip>
                <v-chip small>运营</v-chip>
                <v-chip small>设计</v-chip>
                <v-chip small>技术</v-chip>
              </v-chip-group>
            </v-col>
            <v-col cols="12" md="10">
              <v-row>
                <v-col cols="12" sm="6" md="3" v-for="n in 4" :key="n">
                  <v-select
                    :items="['毕业年份', '学历要求', '企业性质', '更多筛选']"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-btn color="error" block>清除筛选条件</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" v-for="n in 3" :key="n">
              <v-card outlined>
                <v-card-title>
                  <v-chip color="error" label small class="mr-2">最新</v-chip>
                  Job Title
                </v-card-title>
                <v-card-subtitle>Company Name - Location</v-card-subtitle>
                <v-card-text>Job description and requirements...</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "JobSearchPage",
  data: () => ({
    menuItems: [
      "校招",
      "会员信息表",
      "职位",
      "课程中心",
      "关于我们",
      "企业合作",
    ],
  }),
};
</script>